<template lang="html">
<section class="build-link">
    <v-dialog v-model="open.open" max-width="290">
        <v-card class="pa-3">
            <v-card-title class="headline">
                יצירת לינק
            </v-card-title>

            <v-combobox :items="Object.entries(types)" v-model="type" item-text="1"></v-combobox>
            <v-text-field v-model="form.link" label="לינק מלא" v-if="['1', '8'].includes(type[0])"></v-text-field>
            <v-text-field v-model="form.screenDS" label="מספר התוכנית"  v-if="type[0] == 4 || type[0] == 7"></v-text-field>
            <v-text-field v-model="form.itemId" label="מספר האייטם" v-if="['4', '8'].includes(type[0])"></v-text-field>
            <v-text-field v-model="form.screen" label="מספר מסך"  v-if="type[0] == 6"></v-text-field>
            <v-combobox v-model="form.liveTV" :items="Object.entries(livesTV)" item-text="1" label="התחנה" v-if="type[0] == 2"></v-combobox>
            <v-combobox v-model="form.liveRadio" :items="Object.entries(livesRadio)" item-text="1" label="תחנת רדיו" v-if="type[0] == 3"></v-combobox>
            <v-combobox v-model="form.subClass" :items="Object.entries(subClass)" item-text="1" label="מקור" v-if="type[0] == 7"></v-combobox>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="green darken-1" text @click="create">
                    צור לינק
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</section>
</template>

<script lang="js">
export default {
    name: 'build-link',
    props: [
        'open'
    ],
    mounted() {

    },
    data() {
        return {
            livesTV: {
                4444: "כאן 11",
                4471: "כאן חינוכית",
                4532: "מכאן"
            },
            livesRadio: {
                4483: "כאן ב'",
                4490: "כאן גימל",
                4504: "כאן 88",
                4497: "כאן תרבות",
                4525: "כאן רקע",
                4511: "כאן מורשת",
                4518:"כאן קול המוזיקה",
                358568: "רדיו מכאן",
                6358611: "רדיו חינוכית",
            },
            subClass: {
                4444: "תוכנית של כאן 11",
                4450:  "תוכנית מרצועת האקטואליה",
                4451: "תוכנית הסכת",
                4464: "סדרת דיגיטל",
                4483: "תוכנית של כאן ב'",
                4448: "סדרת כתבות (חדשות)",

            },
            types: [
                "חדשות",
                "אייטם טקסט",
                "נגן לייב TV",
                "נגן לייב רדיו",
                "VOD / AOD",
                "מבזקים",
                "מסך",
                "עמוד תוכנית",
                "מתוך פיד ב-Zapp"
            ],
            form: {},
            type: ["0", "חדשות"]
        }
    },
    methods: {
        create() {
            this.open.open = false
            const feedLocator ='https%3A%2F%2Fmobapi.kan.org.il%2Fapi%2Fmobile%2FlivePage'
            switch (this.type[0]) {
                case "0":
                    this.$emit('input', {link: `${this.appLink}://present?screen_id=fca67bce-1c8e-4688-8012-acf1431adfdd`, label: "חדשות"})
                    break;

                case '1':
                    this.$emit('input', {link: this.makeItemUrl(), label: `אייטם - ${this.form.link}`})
                    break;

                case "2":
                    this.$emit('input', {link: `${this.appLink}://open?feed_locator=${feedLocator}&id=${this.form.liveTV[0]}&state=inline`, label: `נגן לייב TV - ${this.form.liveTV[1]}`})
                    break;

                case "3":
                    this.$emit('input', {link: `${this.appLink}://open?feed_locator=${feedLocator}&id=${this.form.liveRadio[0]}&state=inline`, label: `נגן לייב רדיו - ${this.form.liveRadio[1]}`})
                    break;
            
                case "4":
                    this.$emit('input', {link: this.makeVODUrl(), label:  `וידאו \ אודיו - ${this.form.itemId}`})
                    break;
                case "5":
                    this.$emit('input', {link: `${this.appLink}://present?screen_id=c0beb255-410c-41db-afee-abb9602b8557`, label: "מבזקים"})
                    break;
                case "6":
                    this.$emit('input', {link:`${this.appLink}://present?screen_id=${this.form.screen}`, label: `מסך - ${this.form.screen}`})
                    break;
                case '7':
                    this.$emit('input', {link: this.makeSubClassUrl(), label: `אייטם - ${this.form.itemId}`})
                    break;
                case "8":
                    this.$emit('input', {link: this.makeFeedZappUel(), label: `אייטם - ${this.form.itemId}`})
        
                    break;

            
                default:
                    break;
            }
        },
        makeItemUrl() {
            var url  =  `${this.form.link}?app=true`
            url = encodeURIComponent(url)
            url = `${this.appLink}://present?link_url=${url}`
            return url
        },
        makeVODUrl() {
            const innerUrl = encodeURIComponent(`https://mobapi.kan.org.il/api/mobile/program?id=${this.form.screenDS}`)
            return `${this.appLink}://open?feed_locator=${innerUrl}&id=${this.form.itemId}&state=inline`
        },
        makeLiveTvUrl(){
            const dataSourceUrl = encodeURIComponent('https://mobapi.kan.org.il/api/mobile/livePage')
            return `${this.appLink}://open?feed_locator=${dataSourceUrl}&id=${this.form.liveTV[0]}&state=inline`
        
        },
        makeSubClassUrl() {
            const innerUrl = encodeURIComponent(`https://mobapi.kan.org.il/api/mobile/subClass?id=${this.form.subClass[0]}`)
            return `${this.appLink}://open?feed_locator=${innerUrl}&id=${this.form.screenDS}`
        },
        makeFeedZappUel(){
            const innerUrl = encodeURIComponent(this.form.link)
            return `${this.appLink}://open?feed_locator=${innerUrl}&id=${this.form.itemId}&state=inline`


        }
    },
    computed: {
        appLink() {
            return this.$route.params.app == "kan" ? 'kan11' : 'channel23'
        }
    }
}
</script>

<style lang="scss" scoped>
.build-link {}
</style>
